import { styled } from 'styled-components';

export const FormWrapper = styled.form`
	width: 100%;
	margin-top: 24px;
`;

export const MaskedInputWrapper = styled.div`
	position: relative;
	width: 100%;
`;

export const Label = styled.div`
	font-size: 14px;
	font-weight: 600;
	line-height: 18px;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin-bottom: 8px;

	& > span {
		color: ${({ theme }) => theme.colors.text.error};
	}
`;

export const MaskedInput = styled.div<{ $hasError?: boolean }>`
	position: relative;

	input {
		background: ${({ theme }) => theme.colors.transparent.light10};
		border: 1px solid
			${({ $hasError, theme }) => ($hasError ? theme.colors.text.error : theme.colors.transparent.light10)};
		height: 42px;
		border-radius: 12px;
		padding: 8px 12px 8px 38px;
		width: 100%;
		font-weight: 400;
		color: ${({ theme }) => theme.colors.text.alwaysWhite};

		&::placeholder {
			font-weight: 400;
			color: ${({ theme }) => theme.colors.text.alwaysWhite};
			opacity: 0.5;
		}

		&:focus,
		&:active {
			border-color: ${({ theme }) => theme.colors.transparent.light60};
		}
	}
`;

export const InputIcon = styled.div<{ $position: 'start' | 'end' }>`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: ${({ $position }) => ($position === 'start' ? '12px' : 'auto')};
	right: ${({ $position }) => ($position === 'end' ? '12px' : 'auto')};
	width: 20px;
	height: 20px;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
		opacity: 0.5;
		width: 100%;
		height: 100%;
		cursor: ${({ $position }) => ($position === 'end' ? 'pointer' : 'default')};
	}
`;

export const Error = styled.div`
	color: ${({ theme }) => theme.colors.text.error};
	font-size: 12px;
	text-align: center;
	margin-top: 10px;
`;
